// extracted by mini-css-extract-plugin
export default {"card":"b5-z"};